import { createContext } from 'react';

export const KeycloakContext = createContext();
export const SessionContext = createContext();
export const SimulatorContext = createContext();
export const AgileSimulatorContext = createContext();
export const ClientRegistrationContext = createContext();
export const GlobalDebtContext = createContext();
export const MeansOfDisbursementContext = createContext();
export const DataSolicitationContext = createContext();
export const ExceptionContext = createContext();
export const InternationalOperationsContext = createContext();
export const ApSecureContext = createContext();
export const ReferencesContext = createContext();
export const LifeInsuranceContext = createContext();
export const DocumentSigningContext = createContext();
export const IdentityValidationContext = createContext();
export const HabeasDataSenderContext = createContext();
export const LiquidacionPagosContext = createContext();